import { DocumentDetailsInterface } from "../../../assets/interface/primeSharkWebsite_interface";
import HelperService from "../../../Services/HelperService";
import TickIcon from "../../../assets/images/tick.svg";
import CommonModal from "../../Common/CommonModal";
import { useState } from "react";
import { Button, Col } from "react-bootstrap";
import WebService from "../../../Services/WebService";
import { toast } from "react-toastify";
import DeleteModal from "../../Common/DeleteModal/DeleteModal";
interface DocumentNameProps {
  document: DocumentDetailsInterface;
  infoCall:()=>void
}

const DocumentNameDisplay = ({ document ,infoCall}: DocumentNameProps) => {
  console.log(document, "docum");

  const [showModal, setShowModal] = useState(false);
  const [modalUrl, setModalUrl] = useState<string>("");
  const [modalTitle, setModalTitle] = useState<string>("");
  const [fileTitle, setFileTitle] = useState<string>("");
  const [showDelete, setShowDelete] = useState(false);
  const handleView = (url: string, file_title: string = "", title: string) => {
    setModalUrl(url);
    setModalTitle(title);
    setShowModal(true);
    setFileTitle(file_title);
  };
 
  return (
    <div className="d-flex gap-2 justify-content-between">
      <Col
        lg={12}
        sm={12}
        key={"123"}
        className="mb-3 d-flex justify-content-between"
      >
        <div className="d-flex text-end">
          <label className="text-secondary font-bold font-10">
            {HelperService.removeUnderScore(document?.type)} Uploaded{" "}
            <img src={TickIcon} style={{ height: "20px" }} />
          </label>
        </div>
        <div className="d-flex align-items-center gap-2">
          <Button
            variant=""
            size="sm"
            className="btn-outline-secondary w-100"
            onClick={() =>
              handleView(
                document.file_name,
                document?.file_title,
                document?.title,
              )
            }
          >
            View
          </Button>
          <div style={{ width: "80px" }}>
            <Button
              variant=""
              size="sm"
              className="btn-outline-danger w-100"
              onClick={() => setShowDelete(true)}
            >
              Remove
            </Button>
          </div>
        </div>
      </Col>

      {showModal && (
        <CommonModal
          show={showModal}
          handleClose={() => setShowModal(false)}
          fileTitle={fileTitle}
          title={modalTitle}
          url={modalUrl}
        />
      )}

      {showDelete && (
        <DeleteModal
          show={showDelete}
          onDelete={(flag: boolean) => {
            if (flag) {
             infoCall()
            }
            setShowDelete(false);
          }}
          action={`business-document/${document?.id}`}
          message={"Are you sure you want to delete the document?"}
          api={"DELETE"}
        />
      )}
    </div>
  );
};
export default DocumentNameDisplay;
